// Modules
import React from 'react'
import { Typography } from '@dasa-health/components-react'
import { Spacing } from '@dasa-health/alma-react'

// Components
import { TemplateContainer } from 'redesign/components/templates'

// Application
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { CPFPhasedLoginForm } from '../CPFPhasedLoginForm'
import { CustomSpacing } from './styles'
import { WarningServiceIsDown } from '../WarningServiceIsDown'

export const CPFPhasedLogin = () => {
    const { title, isAuthServiceDown } = useCPFLoginForm()
    const { isServiceDown } = isAuthServiceDown()

    return (
        <TemplateContainer renderHeader>
            <CustomSpacing />
            <Typography as="h1" size={4} sx={{ color: 'rgba(22, 22, 22, 1)', fontWeight: '700', lineHeight: '1.8rem' }}>
                {title}
            </Typography>
            <Spacing height={16} />
            <Typography as="h2" size={1} sx={{ color: 'rgba(102, 102, 102, 1)', marginTop: '-8px' }} weight={400}>
                Agende exames, consultas, vacinas e acompanhe seus resultados.
            </Typography>
            {isServiceDown && <WarningServiceIsDown />}
            <CPFPhasedLoginForm />
        </TemplateContainer>
    )
}
